import React, { Component } from "react";
import { Row, Form, Col } from "react-bootstrap";
import debounce from "lodash-es/debounce";
import PaymentsListTable from "./components/payment_list_table.component";
import { Api } from "../utils/api";
import Grid from "@material-ui/core/Grid";
import TablePagination from "@material-ui/core/TablePagination";
import { PaymentFilterForm } from "./forms/payment-filter.form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { observer } from "mobx-react";

const rowsPerPage = 50;

const PaymentsListing = observer(
  class PaymentsListing extends Component {
    constructor() {
      super();
      this.api = new Api();
      this.search = debounce(this.searchInitial.bind(this), 250, {
        leading: true,
      });
      this.onChange = this.onChange.bind(this);
      this.handleChangePage = this.handleChangePage.bind(this);
      this.advancedChange = this.advancedChange.bind(this);
      this.toggleAdvancedFilter = this.toggleAdvancedFilter.bind(this);
    }

    componentDidMount() {
      this.search();
    }

    /**
     * Search
     */

    searchInitial() {
      const { query, searchValues } = this.props.store;
      const params = { search: query, ...searchValues };
      const { page } = this.props.store;

      this.api
        .get("/easypay_payments", {
          ...params,
          page: page + 1,
          rows: rowsPerPage,
        })
        .then(({ data: { easypay_payments, count } }) => {
          this.props.store.setEasypayPayments(easypay_payments);
          this.props.store.setCount(count);
        });
    }

    /**
     * Other search components
     */

    handleChangePage(event, page) {
      this.props.store.setPage(page);
      this.search();
    }

    onChange(event) {
      this.props.store.setQuery(event.target.value);
      this.search();
    }

    toggleAdvancedFilter() {
      this.props.store.toggleAdvancedFilter();
      this.search();
    }

    advancedChange(query) {
      this.props.store.setSearchValues(query);
      this.search();
    }

    /**
     *
     */

    render() {
      return this.props.store.easypay_payments ? (
        this.renderList()
      ) : (
        <div>
          <CircularProgress color="primary" />
        </div>
      );
    }

    renderList() {
      const { easypay_payments } = this.props.store;

      return (
        <>
          <Row className="align-mid">
            <Col md={8}>
              <Form style={{ width: "100%" }}>
                <Form.Control
                  type="text"
                  placeholder="Pesquisar por nome de entidade ou equipamento..."
                  onChange={this.onChange}
                />
              </Form>
            </Col>
            <Col md={2}>
              <Typography variant="body2">
                <Button
                  size="small"
                  color="primary"
                  onClick={this.toggleAdvancedFilter.bind(this)}
                >
                  <FontAwesomeIcon icon="filter" className="filter" />
                  Filtro Avançado
                </Button>
              </Typography>
            </Col>
          </Row>
          {this.props.store.advancedFilter && (
            <Col md={8}>
              <PaymentFilterForm
                searchValues={this.props.store.searchValues}
                onChange={this.advancedChange}
              ></PaymentFilterForm>
            </Col>
          )}

          <PaymentsListTable
            payments={easypay_payments}
            rowsPerPage={rowsPerPage}
            showHistoryLink={true}
            showNewInvoice={true}
          />

          <Grid container>
            <Grid item md={12}>
              <TablePagination
                className="pagination"
                rowsPerPageOptions={[]}
                count={this.props.store.count}
                rowsPerPage={rowsPerPage}
                page={this.props.store.page}
                onChangePage={this.handleChangePage}
              />
            </Grid>
          </Grid>
        </>
      );
    }
  }
);

export default PaymentsListing;
